import { Icon, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { VALIDATION_ERRORS } from '@hero/constants';
import { useNotification } from '@hero/store/hooks';

export function useDeleteModalTemplate({ title, message, confirmText, maxLength, ...props }) {
  const { t } = useTranslation();
  const { showNotification } = useNotification();

  const deleteSchema = yup.object({
    deleteItem: yup
      .string()
      .test(
        'equal',
        <Trans
          i18nKey={VALIDATION_ERRORS.noProvidedInformation}
          components={{ strong: <strong /> }}
        />,
        function (v) {
          return v?.toUpperCase() === confirmText;
        }
      )
  });

  return {
    showDeleteModal: ({ onSubmit, ...dyProps }) => {
      showNotification({
        ...props,
        ...dyProps,
        notificationImage: <Icon name="error" size="xxl" color="var(--color-error-default)" />,
        title,
        message,
        primaryButtonProps: {
          color: 'error',
          children: t('yesDelete')
        },
        formData: [
          {
            name: 'deleteItem',
            title: (
              <Typography variant="body2Bold" style={{ marginBottom: 4 }}>
                {t('typeTheConfirm', { confirmText: confirmText })}
              </Typography>
            ),
            type: 'text',
            minLength: 10,
            maxLength
          }
        ],
        secondaryButtonProps: { children: t('cancel') },
        onSubmit: async ({ formValues, validate }) => {
          const isValid = await validate([{ rule: deleteSchema, value: formValues }]);
          if (!isValid) return true;

          if (onSubmit) {
            onSubmit({ formValues, validate });
          }
        }
      });
    }
  };
}
